<template>
<div class="chapter">
<div class="inner_page">
<a id="page_4"></a>
<p class="dedit">Dedicated to the courage and sacrifice of the men and women who served, as well as the patriots of the resistance groups with whom they fought and died.</p>
<p class="dedict">The life that I have</p>
<p class="dedic">Is all that I have</p>
<p class="dedic">And the life that I have</p>
<p class="dedic">Is yours</p>
<p class="dedict">The love that I have</p>
<p class="dedic">Of the life that I have</p>
<p class="dedic">Is yours and yours and yours</p>
<p class="dedict">A sleep I shall have</p>
<p class="dedic">A rest I shall have</p>
<p class="dedic">Yet death will be but a pause</p>
<p class="dedict">For the peace of my years</p>
<p class="dedic">In the long green grass</p>
<p class="dedic">Will be yours and yours</p>
<p class="dedic">and yours</p>
<p class="dedi1">SOE agent Violette Szabo, <a href="#/xhtml/06_Glossary#rgloss_48" id="gloss_48">GC</a>, used these lines as a code poem on her second and final mission. It was written by Leo Marks, a SOE cryptographer, after he learned of the death of his fiancée. He provided it to Szabo, but did not tell her of its origin.</p>
<p class="dedir">– Leo Marks, <em class="italic">Between Silk and Cyanide</em></p>
<p class="dedir">(London: Harper Collins, 1998)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?0a054c7a